"use strict";
// tslint:disable: no-if-statement
// tslint:disable: no-object-mutation
// tslint:disable: no-expression-statement
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sets `window.history.scrollRestoration` to `manual` and returns a
 * function that will restore it to its previous value.
 */
exports.disableAutoScrollRestoration = function () {
    // https://developer.mozilla.org/en-US/docs/Web/API/History#Browser_compatibility
    if ("scrollRestoration" in window.history) {
        var original_1 = window.history.scrollRestoration;
        window.history.scrollRestoration = "manual";
        return function () { return (window.history.scrollRestoration = original_1); };
    }
    else {
        // tslint:disable-next-line: no-empty
        return function () { };
    }
};
